import _defineProperty from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
var _combineReducers;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import storage from '../utils/safeAsyncStorageProvider';
import { combineReducers } from '../node_modules/redux';
import { persistReducer } from '../node_modules/redux-persist';
import autoMergeLevel2 from '../node_modules/redux-persist/lib/stateReconciler/autoMergeLevel2';
import { apiBaseReducer, apiBaseReducerPath } from './api/services/rtkQuery/apiBaseQuery';
import { LOGOUT } from './actions/types';
import agsiReducer from './reducers/agsiReducer';
import { apiRootReducer } from './reducers/apiRootReducer';
import appReducer from './reducers/appReducer';
import attPermissionReducer from './reducers/attPermissionReducer';
import audioReducer from './reducers/audioReducer';
import { authorizedReducer, fbTokenReducer, lastActiveReducer, restartReducer, tokenReducer } from './reducers/authReducer';
import availableServicesReducer from './reducers/availableServicesReducer';
import { betInfoReducer } from './reducers/betInfoReducer';
import currentOnboardingReducer from './reducers/currentOnboardingReducer';
import { deviceReducer } from './reducers/deviceReducer';
import { appsFlyerValidationReducer, coinReducer, lastWinReducer, loyaltyReducer, ltoReducer, premiumReducer, timeRemainingReducer, videoAdsReducer } from './reducers/extrasReducer';
import featureFlagsReducer from './reducers/featureFlagsReducer';
import formInfoReducer from './reducers/formInfoReducer';
import ftueReducer from './reducers/ftueReducer';
import gameDownloadReducer from './reducers/gameDownloadReducer';
import { favouriteGameReducer, featuredGamesReducer, gameInfoReducer, newGamesReducer, slotGamesReducer, sportsGamesReducer, tableGamesReducer, vipGamesReducer } from './reducers/gameReducer';
import loadReducer from './reducers/loadReducer';
import modalReducer from './reducers/modalReducer';
import navStateReducer from './reducers/navStateReducer';
import notificationReducer from './reducers/notificationReducer';
import pendingMessagesReducer from './reducers/pendingMessagesReducer';
import { playerInfoReducer } from './reducers/playerInfoReducer';
import { prePurchaseReducer } from './reducers/prePurchaseReducer';
import { promotionsReducer } from './reducers/promotionsReducer';
import { purchaseReducer } from './reducers/purchaseReducer';
import rateTheAppReducer from './reducers/rateTheAppReducer';
import { rewardCenterReducer } from './reducers/rewardCenterReducer';
import { shopListReducer } from './reducers/shopListReducer';
import sidebarStateReducer from './reducers/sidebarStateReducer';
import { tooltipReducer } from './reducers/tooltipReducer';
import { updateReducer } from './reducers/updateReducer';
import actionCommandsReducer from './slices/actionCommands/actionCommands';
import assetsPackageReducer from './slices/assetsPackage/assetsPackage';
import consumablesReducer from './slices/consumables/consumables';
import layoutReducer from './slices/layout/layout';
import levelInfoReducer from './slices/level/level';
import loginProgressReducer from './slices/login/loginProgress';
import missionsReducer from './slices/missions/missions';
import progressiveJackpotsReducer from './slices/progressiveJackpots/progressiveJackpots';
import propertiesReducer from './slices/properties/properties';
import spinEventReducer from './slices/spinEvent/spinEvent';
import tutorialReducer from './slices/tutorial/tutorial';
import xpInfoReducer from './slices/xp/xp';
import gameRoomsReducer from './slices/gameRooms/gameRooms';
var persistConfig = {
  key: 'root',
  storage: storage,
  stateReconciler: autoMergeLevel2,
  timeout: 0,
  whitelist: ['token', 'restart', 'lastActive', 'prePurchase', 'shopList', 'apiRootIndex', 'legal', 'level', 'ftue', 'rateTheApp', 'pendingMessages', 'notifications', 'attPermission'],
  blacklist: ['gameDownload']
};
var appPersistConfig = {
  key: 'app',
  storage: storage,
  stateReconciler: autoMergeLevel2,
  timeout: 0,
  whitelist: ['assetBaseUrl', 'assetsUrls', 'target', 'showCustomModal', 'cacheId', 'currentScreen', 'language']
};
var gameDownloadPersistConfig = {
  key: 'gameDownload',
  storage: storage,
  stateReconciler: autoMergeLevel2,
  timeout: 0,
  whitelist: ['downloadedGames', 'maxDownloadedGames', 'downloadFailedGames']
};
var assetsPackagePersistConfig = {
  key: 'assetsPackage',
  storage: storage,
  stateReconciler: autoMergeLevel2,
  timeout: 0,
  whitelist: ['assetsPackageId', 'lastRevisionNumber']
};
var tutorialPersistConfig = {
  key: 'tutorial',
  storage: storage,
  stateReconciler: autoMergeLevel2,
  timeout: 0,
  whitelist: ['tutorialStep', 'tutorialCompletedOrSkipped']
};
var levelPersistConfig = {
  key: 'level',
  storage: storage,
  stateReconciler: autoMergeLevel2,
  timeout: 0,
  whitelist: ['level', 'max']
};
var purchasePersistConfig = {
  key: 'purchase',
  storage: storage,
  stateReconciler: autoMergeLevel2,
  timeout: 0,
  whitelist: ['actionTrigger']
};
var gameInfoPersistConfig = {
  key: 'gameInfo',
  storage: storage,
  stateReconciler: autoMergeLevel2,
  timeout: 0,
  whitelist: ['gameId']
};
var playerInfoPersistConfig = {
  key: 'playerInfo',
  storage: storage,
  stateReconciler: autoMergeLevel2,
  timeout: 0,
  whitelist: ['playerId', 'casinoIdStatus', 'casinoId', 'isAccountLinked', 'memberLevel', 'propertyId', 'isDevUser', 'aff_id', 'KYCInfo', 'lastTimeRated', 'lastTimeAdBlockerSeen', 'gamesOpenedAmount', 'appsflyerGamesOpenedAmountConfig', 'isKYCDone', 'KYCResult', 'soundEffects', 'music']
};
var applicationReducer = combineReducers((_combineReducers = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_combineReducers, apiBaseReducerPath, apiBaseReducer), "app", persistReducer(appPersistConfig, appReducer)), "load", loadReducer), "device", deviceReducer), "token", tokenReducer), "fbToken", fbTokenReducer), "restart", restartReducer), "authorized", authorizedReducer), "lastActive", lastActiveReducer), "navState", navStateReducer), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_combineReducers, "sidebarState", sidebarStateReducer), "formInfo", formInfoReducer), "modal", modalReducer), "gameInfo", persistReducer(gameInfoPersistConfig, gameInfoReducer)), "newGames", newGamesReducer), "featuredGames", featuredGamesReducer), "slotGames", slotGamesReducer), "tableGames", tableGamesReducer), "vipGames", vipGamesReducer), "sportsGames", sportsGamesReducer), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_combineReducers, "favouriteGames", favouriteGameReducer), "coin", coinReducer), "premium", premiumReducer), "loyalty", loyaltyReducer), "limitedTimeOffer", ltoReducer), "xpInfo", xpInfoReducer), "levelInfo", persistReducer(levelPersistConfig, levelInfoReducer)), "notifications", notificationReducer), "playerInfo", persistReducer(playerInfoPersistConfig, playerInfoReducer)), "prePurchase", prePurchaseReducer), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_combineReducers, "purchase", persistReducer(purchasePersistConfig, purchaseReducer)), "shopList", shopListReducer), "rewardCenter", rewardCenterReducer), "apiRootIndex", apiRootReducer), "consumables", consumablesReducer), "ftue", ftueReducer), "lastWin", lastWinReducer), "rateTheApp", rateTheAppReducer), "betInfo", betInfoReducer), "pendingMessages", pendingMessagesReducer), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_combineReducers, "videoAds", videoAdsReducer), "update", updateReducer), "currentOnboarding", currentOnboardingReducer), "promotions", promotionsReducer), "tooltip", tooltipReducer), "availableServices", availableServicesReducer), "audio", audioReducer), "timeRemaining", timeRemainingReducer), "appsFlyerValidation", appsFlyerValidationReducer), "attPermission", attPermissionReducer), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_combineReducers, "gameDownload", persistReducer(gameDownloadPersistConfig, gameDownloadReducer)), "featureFlags", featureFlagsReducer), "agsi", agsiReducer), "progressiveJackpots", progressiveJackpotsReducer), "missions", missionsReducer), "assetsPackage", persistReducer(assetsPackagePersistConfig, assetsPackageReducer)), "lastSpinEvents", spinEventReducer), "tutorial", persistReducer(tutorialPersistConfig, tutorialReducer)), "properties", propertiesReducer), "loginProgressState", loginProgressReducer), _defineProperty(_defineProperty(_defineProperty(_combineReducers, "actionCommands", actionCommandsReducer), "layout", layoutReducer), "gameRooms", gameRoomsReducer)));
var rootReducer = function rootReducer(state, action) {
  if (action.type === LOGOUT) {
    var _state = state,
      attPermission = _state.attPermission,
      token = _state.token,
      audio = _state.audio,
      pendingMessages = _state.pendingMessages,
      app = _state.app;
    state = undefined;
    state = _objectSpread({
      audio: audio,
      attPermission: attPermission,
      token: {
        lastLoginInfo: token.lastLoginInfo
      },
      app: app
    }, action.payload && {
      pendingMessages: pendingMessages
    });
  }
  return applicationReducer(state, action);
};
export var pReducer = persistReducer(persistConfig, rootReducer);